<template>
  <div class="hero">
    <div class="pic" v-if="pic">
      <div>
        <p v-html="eng"></p>
        <h1 v-html="title"></h1>
      </div>
      <img :src="pic" :alt="title" class="rellax-no">
    </div>
    <div class="bread">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hero{
  position: relative;
  top: 0;
  left: 0;
}
.pic{
  position: relative;
  padding: calc(100% / 16 * 4) 0 0;
  min-height: 20rem;
  overflow: hidden;
  @media screen and (max-width: module.$phone){
    min-height: 14rem;
  }
  &:before{
    content: '';
    width: 100%;
    height: 100%;
    background: module.$black;
    position: absolute;
    top: 0;
    left: 0;
    opacity: .64;
    z-index: 2;
  }
  img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  div{
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    color: module.$white;
    text-align: center;
    line-height: 1.4;
    font-weight: 700;
    width: 90%;
    p{
      font-size: 4.6rem;
      @media screen and (max-width: module.$phone){
        font-size: 2.4rem;
      }
    }
    h1{
      font-size: 1.24rem;
      @media screen and (max-width: module.$phone){
        font-size: 1rem;
      }
    }
  }
}

.bread{
  position: absolute;
  left: module.side();
  bottom: 0;
  z-index: 10;
  transform: translateY(50%);
  @media screen and (max-width: module.$phone){
    left: 0;
  }
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    eng: {
      type: String,
      required: false
    },
    pic: {
      type: String,
      required: false
    },
  }
}
</script>
